module.exports = __webpack_public_path__ + "static/media/add_btn.d24a2da9.svg";